import React from "react";
import { Gem } from "lucide-react";
import { PREMIUM_JOB } from "services/constants";

interface PremiumJobIconProps {
  jobPlan: string;
}

const PremiumJobIcon: React.FC<PremiumJobIconProps> = ({ jobPlan }) => {
  if (jobPlan !== PREMIUM_JOB) {
    return null;
  }

  return (
    <div className="h-6 w-6 bg-muted2 flex items-center justify-center rounded-full">
      <Gem size={12} className="text-discovery-foreground" />
    </div>
  );
};

export default PremiumJobIcon;
